// extracted by mini-css-extract-plugin
module.exports = {"infoItems":"styles_infoItems__1_68V","orderInfo":"styles_orderInfo__3E72m","cardContent":"styles_cardContent__3lk3z"};